import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import { Location } from "@angular/common";
import { CategoriaService } from "src/app/services/categorias/categoria";
import { ConfirmationService, MessageService } from "primeng/api";
import { FechasService } from "src/app/services/fechas/fechas";
import { ColumnManagerService } from "src/app/services/column-manager/column-manager.service";
import { routes } from "src/app/app.routes";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormManagerService } from "src/app/services/form-manager/form-manager.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-form-manager",
  templateUrl: "./form-manager.component.html",
  styleUrls: ["./form-manager.component.css"],
  providers: [CategoriaService, MessageService, FechasService, ConfirmationService],
})
export class FormManagerComponent implements OnInit {
  @Input() displayFormManager: boolean;
  @Output() cerrarFormManager = new EventEmitter();

  availableColumns: any[] = [];
  selectedColumns: any[] = [];
  dropIndex: number | null = null;

  update: boolean = false;
  id: any = "";

  loaderSubmit: boolean = false;

  childrenDatabaseName: string = "";

  columnForm: FormGroup;
  editMode: boolean = false;
  columnToEdit: any = null;

  columnTypes = [
    { label: "Varchar", value: "varchar" },
    { label: "Int", value: "int" },
    { label: "Date", value: "date" },
    { label: "Longtext", value: "longtext" },
    { label: "Decimal", value: "decimal" },
    { label: "Float", value: "float" },
    { label: "Double", value: "double" },
    { label: "Char", value: "char" },
    { label: "Boolean", value: "boolean" },
  ];


  inputTypes = [
    { label: "Text", value: "text" },
    { label: 'Date', value: "date" },
    { label: "File", value: "file" },
    { label: "Dropdown", value: "dropdown" },
    { label: "Switch", value: "switch" },
    { label: "Switch Group", value: "switch-"}
  ]

  message: string = ''

  draggedColumnIndex: number | null = null;

  constructor(
    private columnService: ColumnManagerService,
    private formService: FormManagerService,
    private location: Location,
    private router: Router,
    private messageService: MessageService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService
  ) {
    this.columnForm = this.fb.group({
      newColumnName: ["", Validators.required],
      newColumnType: ["", Validators.required],
      newColumnNameInput: ["", Validators.required],
      newColumnComment: ["", Validators.required],
      columnLength: [null],
      columnTypeGroup: [""],
      columnOrder: [""]
    });
  }

  ngOnInit() {
    if (environment.appName === 'campanaragricola'){
      return
    }

    // Every time user reaches a new route, this.updateRouteData will be called
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateRouteData();
      });

    this.updateRouteData();

  }

  private updateRouteData() {
    const nameUrl = this.location.path().replace("/dashboard/", "");
    const dashboardRoute = routes.find((route) => route.path === "dashboard");
    if (dashboardRoute) {
      const children = dashboardRoute.children.find(
        (child) => child.path === nameUrl
      );
      if (children && children.data) {
        this.childrenDatabaseName = children.data.database || "";
      } else {
        this.childrenDatabaseName = "";
      }
      this.childrenDatabaseName = this.childrenDatabaseName || nameUrl;
      if (
        this.childrenDatabaseName &&
        !this.childrenDatabaseName.includes("/")
      ) {
        this.loadTableColumns(this.childrenDatabaseName);
      }
    }
  }

  // Obtains all fields from a table
  async loadTableColumns(tableName: string): Promise<void> {
    try {
      const response: any = await this.columnService
        .fetchColumnComments(tableName)
        .toPromise();
      if (response.status === 200) {
        const columnComments = response.columns_info;
        this.availableColumns = Object.keys(columnComments)
          .filter((columnName) => columnName !== "id" && columnName !== 'revision')
          .map((columnName) => {

            const commentParts = columnComments[columnName].comment.split('|')
            const order = commentParts.length > 2 ? parseInt(commentParts[2], 10) : 9999
            return {
              name: columnName,
              value: columnComments[columnName].type,
              comment: columnComments[columnName].comment,
              order: order
            };
          });

          this.availableColumns.sort((a, b) => a.order - b.order)
      } else {
        console.error("Error loading column comments:", response.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async addNewColumn() {
    this.loaderSubmit = true;
    const tableName = this.childrenDatabaseName;

    if (this.columnForm.invalid) {
      this.messageService.add({
        severity: "warn",
        summary: "Warning",
        detail: "Please fill all fields",
      });
      return;
    }

    const {
      newColumnName,
      newColumnType,
      columnLength,
      newColumnNameInput,
      newColumnComment,
      columnTypeGroup,
      columnOrder
    } = this.columnForm.value;

    let typeColumn = "";

    if (
      newColumnType &&
      (newColumnType === "varchar" ||
        newColumnType === "char" ||
        newColumnType === "int")
    ) {
      typeColumn = `${newColumnType}(${columnLength})`;
    } else {
      typeColumn = newColumnType;
    }

    let typeInputColumn = ""

    if (newColumnComment && newColumnComment === 'switch-'){
      typeInputColumn = `${newColumnComment}${columnTypeGroup}`
    }else{
      typeInputColumn = newColumnComment
    }

    const maxOrder = this.availableColumns.reduce((prev, current) => current.order > prev.order ? current : prev)
    //console.log(maxOrder)
    let newColumnOrder;

    if (!columnOrder){
      newColumnOrder = maxOrder.order + 1
    }else{
      newColumnOrder = columnOrder
    }

    //console.log(newColumnOrder)

    const commentColumn = `${newColumnNameInput}|${typeInputColumn}|${newColumnOrder}`;

    const objectColumn = {
      tableName,
      newColumnName,
      typeColumn,
      commentColumn,
    };
    //console.log(objectColumn);

    try {
      const response: any = await this.formService
        .addColumnToTable(objectColumn)
        .toPromise();
      //console.log(response);

      if (response.status === 200) {
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Column added successfully",
        });
        this.resetForm();
        this.loadTableColumns(this.childrenDatabaseName);
      } else {
        this.message = response.message
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: response.message,
        });
      }
    } catch (error) {
      //console.error("Error:", error);
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "An error occurred",
      });
    } finally {
      this.loaderSubmit = false;
    }
  }

  editColumn(column: any) {
    this.editMode = true;
    this.columnToEdit = column;

    const nameColumn = column.name
    const typeMatch = column.value.match(/\w+/);
    const lengthMatch = column.value.match(/\d+/);

    const [commentName, commentType, commentOrder] = column.comment.split("|");
    const type = typeMatch ? typeMatch[0] : "";
    const length = lengthMatch ? lengthMatch[0] : "";

    let typeInput = "";
    let groupInput = "";

    if (commentType && commentType.includes('-')) {
      const splitIndex = commentType.indexOf('-') + 1
      typeInput = commentType.substring(0, splitIndex)
      groupInput = commentType.substring(splitIndex)
    } else {
      typeInput = commentType;
    }

    this.columnForm.patchValue({
      newColumnName: nameColumn,
      newColumnType: type,
      newColumnNameInput: commentName,
      newColumnComment: typeInput,
      columnLength: length,
      columnTypeGroup: groupInput,
      columnOrder: commentOrder
    });

    this.onColumnTypeChange({ target: { value: type } } as any);

    this.onColumnInputTypeChange({ target: {value: typeInput}} as any)

  }

  async updateColumn() {
    this.loaderSubmit = true;
    const tableName = this.childrenDatabaseName;

    if (this.columnForm.invalid) {
      this.messageService.add({
        severity: "warn",
        summary: "Warning",
        detail: "Please fill all fields",
      });
      return;
    }

    const {
      newColumnName,
      newColumnType,
      columnLength,
      newColumnNameInput,
      newColumnComment,
      columnTypeGroup,
      columnOrder
    } = this.columnForm.value;

    let typeColumn = "";
    if (
      newColumnType &&
      (newColumnType === "varchar" ||
        newColumnType === "char" ||
        newColumnType === "int")
    ) {
      typeColumn = `${newColumnType}(${columnLength})`;
    } else {
      typeColumn = newColumnType;
    }

    let typeInputColumn = ""

    if (newColumnComment && newColumnComment === 'switch-'){
      typeInputColumn = `${newColumnComment}${columnTypeGroup}`
    }else{
      typeInputColumn = newColumnComment
    }

    const commentColumn = `${newColumnNameInput}|${typeInputColumn}|${columnOrder}`;

    const currentColumnName = this.columnToEdit.name

    const objectColumn = {
      tableName,
      currentColumnName,
      newColumnName,
      typeColumn,
      commentColumn,
    };

    //console.log(objectColumn);

    try {
      const response: any = await this.formService
        .editColumnInTable(objectColumn)
        .toPromise();
      //console.log(response);

      if (response.status === 200) {
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Column modified successfully",
        });
        this.resetForm();
        this.loadTableColumns(this.childrenDatabaseName);
      } else {
        this.message = response.message
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: response.message,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "An error occurred",
      });
    } finally {
      this.loaderSubmit = false;
    }
  }

  resetForm() {
    this.columnForm.reset();
    this.editMode = false;
    this.columnToEdit = null;
  }

  confirmDeleteColumn(columnName: string, event: Event) {
    event.stopPropagation();

    this.confirmationService.confirm({
      message: '¿Seguro que quieres borrar esta columna?',
      header: `Confirmación borrar ${columnName}`,
      acceptLabel: 'Sí', // Texto del botón de confirmación
      rejectLabel: 'No', // Texto del botón de rechazo
      // icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteColumn(columnName);
      },
      reject: () => {
        this.messageService.add({severity:'info', summary:'Cancelled', detail:'You have cancelled'});
      }
    });
  }

  async deleteColumn(columnName: string) {
    //console.log("Deleting column:", columnName);
    const tableName = this.childrenDatabaseName;

    const objectColumn = {
      tableName,
      columnName
    };

    //console.log(objectColumn);

    try {
      const response: any = await this.formService
        .deleteColumnFromTable(objectColumn)
        .toPromise();
      //console.log(response);

      if (response.status === 200) {
        this.messageService.add({
          severity: "success",
          summary: "Success",
          detail: "Column deleted successfully",
        });
        this.loadTableColumns(tableName);
      } else {
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: response.message,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      this.messageService.add({
        severity: "error",
        summary: "Error",
        detail: "An error occurred",
      });
    } finally {
      this.resetForm();
    }
  }


  onColumnTypeChange(event: Event) {
    const selectedType = (event.target as HTMLSelectElement).value;
    if (
      selectedType === "varchar" ||
      selectedType === "char" ||
      selectedType === "int"
    ) {
      this.columnForm.get("columnLength").setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.columnForm.get("columnLength").clearValidators();
    }
    this.columnForm.get("columnLength").updateValueAndValidity();
  }

  onColumnInputTypeChange(event: Event){

    const selectedType = (event.target as HTMLSelectElement).value

    if (selectedType === "switch-"){
      this.columnForm.get("columnTypeGroup").setValidators(Validators.required)
    }else{
      this.columnForm.get("columnTypeGroup").clearValidators()
    }
    this.columnForm.get("columnTypeGroup").updateValueAndValidity()


  }

  updateColumnOrder() {
    const columnsData = {
      tableName: this.childrenDatabaseName,
      columns: this.availableColumns.map((col, index) => ({
        name: col.name,
        comment: `${col.comment.split('|')[0]}|${col.comment.split('|')[1]}|${index}`
      }))
    };

    this.formService.updateColumnOrder(columnsData).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.messageService.add({
            severity: "success",
            summary: "Success",
            detail: "Column order updated successfully",
          });
        this.loadTableColumns(this.childrenDatabaseName);
        } else {
          this.messageService.add({
            severity: "error",
            summary: "Error",
            detail: response.message,
          });
        }
      },
      (error) => {
        console.error("Error:", error);
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "An error occurred",
        });
      }
    );
  }


  cerrarVentanaFormManager() {
    this.resetForm()
    this.cerrarFormManager.emit({});
  }


  // Drag and drop functionality

  onDragStart(event: DragEvent, index: number) {
    this.draggedColumnIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.setData('text', String(index));
    }
  }


  onDragOver(event: DragEvent, index: number) {
    event.preventDefault();
    if (this.draggedColumnIndex !== null && this.draggedColumnIndex !== index) {
      const draggedColumn = this.availableColumns[this.draggedColumnIndex];
      const remainingColumns = this.availableColumns.filter((_, i) => i !== this.draggedColumnIndex);
      this.availableColumns = [
        ...remainingColumns.slice(0, index),
        draggedColumn,
        ...remainingColumns.slice(index)
      ];
      this.draggedColumnIndex = index;
    }
  }

  onDrop(event: DragEvent, index: number) {
    event.preventDefault();
    this.draggedColumnIndex = null;
  }

  onDragEnd() {
    this.draggedColumnIndex = null;
  }
}
